import PageContent from './components/PageContent'

const ProviderDeadLines = () => (
  <PageContent />
)

export default ProviderDeadLines
